import React from 'react';
import { Link } from 'react-router-dom';

export const SUPPORT_EMAIL = 'support@iqmaxx.com';

export interface StaticPageProps {
  title: string;
  intro?: string;
  /**
   * When true the page states that the definitive document is not yet published
   * and tells the reader how to obtain it.
   *
   * Used for Terms and Privacy: registration asks users to accept both, so the
   * routes must resolve — but the binding text is a legal document that has to
   * come from the business, not from engineering. Saying so plainly is honest;
   * inventing plausible-looking terms would not be.
   */
  pendingLegalCopy?: boolean;
  children?: React.ReactNode;
}

const StaticPage: React.FC<StaticPageProps> = ({
  title,
  intro,
  pendingLegalCopy = false,
  children,
}) => (
  <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 20px 64px' }}>
    <h1 style={{ marginBottom: 8 }}>{title}</h1>
    {intro && <p style={{ color: '#666', marginTop: 0, fontSize: 16 }}>{intro}</p>}

    {pendingLegalCopy && (
      <div
        role="note"
        style={{
          background: '#fff8e6',
          border: '1px solid #f5a623',
          borderRadius: 8,
          padding: '14px 16px',
          margin: '20px 0',
          fontSize: 14,
          color: '#7a4d06',
        }}
      >
        <strong style={{ display: 'block', marginBottom: 4 }}>
          Este documento aún no está publicado.
        </strong>
        Estamos finalizando la versión definitiva. Mientras tanto puedes solicitar una copia
        escribiendo a <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>, y te la enviamos.
      </div>
    )}

    {children}

    <p style={{ marginTop: 32, fontSize: 14, color: '#666' }}>
      ¿Tienes dudas? <Link to="/contact">Contáctanos</Link>.
    </p>
  </div>
);

export default StaticPage;
